// MobileLoginTailwind.js
export const commonUsedClass = {
    plFlex: 'flex items-center',
    plFlexRow: 'flex justify-center items-center flex-row',
    plFlexCol: 'flex justify-center items-center flex-col',
    plFlexColS: 'flex justify-start items-center flex-col',
    inpNormal: 'form-control border-danger transparent-input-border',
    inpErr:'form-control transparent-input-border',
    pwdEye:'absolute top-1/2 -translate-y-1/2 right-4 p-2 cursor-pointer',
    smallTxt:'text-sm text-accent font-normal ',
    inpcon:'my-2 py-2',
    btncon:'btn btn_primary_black text-white w-full rounded-md'
  };
  
  export const mobileLoginViewtalwind = {
    baseContainer: 'min-h-screen w-full overflow-x-hidden overflow-y-auto flex flex-col bg-white font-sans relative',
    topContainer: 'h-[35vh] relative w-full',
    topConImg: 'w-full h-full object-cover',
    bottomContainer: `${commonUsedClass.plFlexColS} !lg:justify-center gap-3 w-full h-full border rounded-t-[40px] bg-white p-6
    relative -mt-[80px] shadow-lg`,
    btmHeadCon:`${commonUsedClass.plFlexCol} gap-3 mt-0 mb-0`,
    baseHeading: 'text-2xl font-medium text-center',
    secondBaseHead: 'text-sm font-normal text-center max-w-80 text-primary_v2',
    loginRMFPCon:`${commonUsedClass.plFlex} justify-between ml-[2px]`,
    rememberMeCon:'flex items-start',
    rememberMe:'text-xs text-primary_v2 ms-1 select-none',
    forgotpassword:`${commonUsedClass.smallTxt} cursor-pointer select-none`,
    DLcon:'mt-3 flex items-ceter justify-center',
    DLLinkTxt:'text-xs text-accent cursor-pointer ml-1',
    DLNormalTxt:'text-xs'

  };
  export const DesktopLoginViewtalwind = {
    LeftContainer: `${commonUsedClass.plFlexCol} gap-4 w-[50vw] pt-[5%] pb-[30px] pl-[10vw] pr-[10vw]  bg-white p-6
      relative -mt-[80px] `,
  };
  export const Forgotpassword = {
     Title:'font-medium text-2xl lg:text-center',
     Titledesc:'text-sm text-primary_v2 mt-4 lg:mt-5'
  }
  